import React from 'react'

function Page500() {
  return (
    <div>Page500</div>
  )
}

export default Page500